
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/analytics/membership",
      function () {
        return require("private-next-pages/admin/analytics/membership.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/analytics/membership"])
      });
    }
  